interface ProgramPage{
    header: string,
    description: string,
    title: string,
}

export const getProgramPagesData  = (city: string) : Map<string, ProgramPage> => {

    const programPagesData = new Map<string, ProgramPage>();

    programPagesData.set('sport', {
        title : 'Программа передач со спортивными ТВ каналами на сегодня',
        header : `Спортивные каналы в ${city}`,
        description : 'Онлайн телепрограмма спортивных каналов с расписанием трансляций матчей на сегодня, завтра и другие дни недели',
    });

    programPagesData.set('detskie', {
        title : 'Детские каналы, программа передач на сегодня онлайн',
        header : `Детские каналы в ${city}`,
        description : 'Онлайн расписание детских каналов - мультфильмы, детские передачи',
    });

    programPagesData.set('movies', {
        title : 'Программа передач с  каналами фильмов и сериалов на сегодня',
        header : `Каналы с фильмами и сериалами в ${city}`,
        description : 'Телепрограмма со всеми телеканалами кино на сегодня, завтра и другие дни недели',
    });

    programPagesData.set('dlya-vrosliyh', {
        title : 'Программа передач ТВ каналов для взрослых 18+',
        header : `ТВ каналы для взрослых в ${city}`,
        description : 'Онлайн телепрограмма каналов с эротикой на сегодня, завтра и другие дни недели',
    });

    programPagesData.set('news', {
        title : 'Программа передач новостных каналов на сегодня',
        header : `Новостные ТВ каналы в ${city}`,
        description : 'Онлайн телепрограмма каналов с новостями на сегодня, завтра и другие дни недели',
    });

    programPagesData.set('public', {
        title : 'Программа передач общедоступных каналов цифрового телевидения на сегодня',
        header : `Общедоступные каналы в ${city}`,
        description : 'Онлайн телепрограмма для развлекательных телеканалов с шоу, комедиями и другими передачи на завтра и другие дни недели',
    });

    programPagesData.set('brain', {
        title : 'Программа передач с  познавательными ТВ каналами на сегодня',
        header : `Познавательные каналы в ${city}`,
        description : 'Онлайн телепрограмма со всеми научными, познавательными и обучающими телеканалами',
    });

    programPagesData.set('razvlekatelnyye', {
        title : `Развлекательные ТВ каналы  – программа передач в ${city}`,
        header : `Развлекательные каналы в ${city}`,
        description : `Актуальная программа передач на сегодня развлекательных каналов от Дом.ру. Смотрите на нашем сайте расписание ТВ-передач в ${city} с точным временем.`,
    });

    programPagesData.set('religion', {
        title : 'Онлайн программа передач религиозных тв каналов на сегодня',
        header : `Религиозные каналы в ${city}`,
        description : 'Онлайн телепрограмма для православных и мусульманских телеканалов на сегодня, завтра и другие дни недели',
    });

    programPagesData.set('music', {
        title : 'Программа передач с музыкальными ТВ каналами на сегодня',
        header : `Музыкальные каналы в ${city}`,
        description : 'Онлайн телепрограмма каналов с русской и зарубежной музыкой на сегодня, завтра и другие дни недели',
    });


    programPagesData.set('national', {
        title : 'Программа передач национальных тв каналов на сегодня',
        header : `Национальные каналы в ${city}`,
        description : 'Онлайн телепрограмма русских, белорусских, татарских и других народов национальных телеканалов на сегодня, завтра и другие дни недели',
    });

    programPagesData.set('mestnye', {
        title : 'Онлайн программа передач каналов местного телевидения на сегодня',
        header : `Местные каналы в ${city}`,
        description : 'Онлайн телепрограмма муниципальных тв каналов на сегодня, завтра и другие дни недели',
    });

    programPagesData.set('telemagaziny', {
        title : 'Онлайн программа передач тв каналов телемагазина на сегодня',
        header : `Телемагазины каналы в ${city}`,
        description : 'Онлайн телепрограмма магазина на диване тв каналов на сегодня, завтра и другие дни недели',
    });


    return programPagesData;

};


export const programCategoriesIdMathces = {
    '1' : 'public',
    '4' : 'movies',
    '2' : 'razvlekatelnyye',
    '5' : 'brain',
    '6' : 'sport',
    '3' : 'detskie',
    '7' : 'music',
    '8' : 'news',
    '10' : 'national',
    '9' : 'religion',
    '14' : '',
    '11' : 'dlya-vrosliyh',
    '12': 'mestnye',
    '13':'telemagaziny',
};

export const programCategoriesNamesMathces = {
    'public' : '1',
    'movies' : '4',
    'razvlekatelnyye' : '2',
    'brain' : '5',
    'sport' : '6',
    'detskie' : '3',
    'music' : '7',
    'news' : '8',
    'national' : '10',
    'religion' : '9',
    ' ' : '14',
    'dlya-vrosliyh' : '11',
    'mestnye':'12',
    'telemagaziny':'13',
};
